import type { Mission } from '../missions.ts'

export const nsa: Mission = {
  id: "nsa",
  name: "National Security Agency",
  short: "NSA",
  call: "Cryptology",
  kind: "subagency",
  parent: "dod",
  community: "intelligence",
  url: "https://www.nsa.gov/",
  established: 1952,
  palette: {
    primary: "#124471",
    secondary: "#94693c",
    accent: "#e0af35",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._National_Security_Agency.svg",
  },
  motif: "key",
  mission: {
    text: "The National Security Agency/Central Security Service (NSA/CSS) leads the U.S. Government in cryptology that encompasses both foreign signals intelligence (SIGINT) insights and cybersecurity products and services and provides the Nation decision advantage in competition, crisis, and conflict.",
    url: "https://www.nsa.gov/about/mission-values/",
  },
  fact: {
    text: "NSA's National Cryptologic Museum, one of the first public museums in the Intelligence Community, has had a research library since it opened in 1993.",
    url: "https://www.nsa.gov/history/national-cryptologic-museum/about-the-museum/",
  },
  seal: {
    file: "public/seals/nsa.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._National_Security_Agency.svg",
  },
  identifier: {
    about: "https://www.nsa.gov/about/",
    accessibility: "https://www.nsa.gov/nsa-accessibility/",
    foia: "https://www.nsa.gov/Helpful-Links/NSA-FOIA/",
    noFear: "https://www.nsa.gov/Helpful-Links/No-Fear-Act/",
    oig: "https://oig.nsa.gov/",
    privacy: "https://www.nsa.gov/Culture/Civil-Liberties-and-Privacy/",
  },
  media: {
    photos: [
      {
        file: "/media/nsa-headquarters.jpg",
        small: "/media/nsa-headquarters-sm.jpg",
        alt: "Aerial view of NSA headquarters at Fort Meade, its dark glass Operations buildings rising above wide parking lots filled with cars, with trees to the horizon.",
        title: "National Security Agency headquarters, Fort Meade, Maryland",
        creator: "National Security Agency",
        source: "https://commons.wikimedia.org/wiki/File:National_Security_Agency_headquarters,_Fort_Meade,_Maryland.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
